import React from 'react';
import VipSetting from '../components/VipSetting';

// Tools & Lists > Set VIP Overlay (Azure exit WS8). VIP_OVERLAY; ws8_set_vip_overlay. I found no
// reader of this setting in the repos searched; user decision 2026-11-01 is that every screen moves.
export default function SetVipOverlay() {
  return (
    <VipSetting
      title="Set VIP Overlay"
      feature="ws8_set_vip_overlay"
      action="set_vip_overlay"
      fieldName="VIP_OVERLAY"
      intro="You can enable the VIP Shop-Thanks overlay here."
      ask="Show overlay?"
      options={[['Yes', 'Yes'], ['No', 'No']]}
      saveLabel="Update Overlay"
    />
  );
}
